<template lang="pug">
.narrow--content
  .input-wrapper
    label(for='final_message') {{i18n.final_message}}
  .input-wrapper
    textarea(name='travel_form[final_message]' id='final_message' rows='5' v-model="form.final_message")
  small(v-html="i18n.info")
</template>

<script>
export default {
  components: {
  },
  props: [
    "i18n",
    "settings",
    "form"
  ],
  data () {
    return {
    }
  },
  mounted () {
  },
  watch: {
  },
  computed: {
  },
  methods: {
  }
}
</script>
